import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import Isvg from 'react-inlinesvg';

import { PFE_ICONS } from 'constants/icons';
import { classNameWithModifiers as withMods } from 'helpers/class-name';

import Message from 'components/Message';

import './ProjectedSpotsConfirmation.scss';

const messages = defineMessages({
  decreasedUnderRecommendation: {
    id: 'yield-management.projected-spots-confirmation.decreased-under-rec',
    defaultMessage:
      'Are you sure you want to reduce spots to {networkCap, number}? Your ClassPass predicted fill for this session is {smartspotRecommendedSpots, plural, one {# spot} other {# spots}}, so you could miss out on {difference, plural, one {# additional booking} other {# additional bookings}}.',
  },
  increasedUnderRecommendation: {
    id: 'yield-management.projected-spots-confirmation.increased-under-rec',
    defaultMessage:
      'Your ClassPass predicted fill for this session is {smartspotRecommendedSpots, number}. We recommend opening up {difference, plural, one {# additional spot} other {# additional spots}} to maximize revenue.',
  },
});

const ProjectedSpotsConfirmation = ({ difference, isDecrease, networkCap, smartspotRecommendedSpots }) => (
  <div className={withMods('projected-spots-confirmation', { isDecrease })}>
    <Isvg
      src={PFE_ICONS.opportunitiesFill}
      className={withMods('projected-spots-confirmation__icon', { isDecrease })}
    />
    <Message
      as="p"
      className="projected-spots-confirmation__message"
      message={isDecrease ? messages.decreasedUnderRecommendation : messages.increasedUnderRecommendation}
      values={{ smartspotRecommendedSpots, networkCap, difference }}
    />
  </div>
);

ProjectedSpotsConfirmation.propTypes = {
  difference: PropTypes.number,
  isDecrease: PropTypes.bool,
  networkCap: PropTypes.number,
  smartspotRecommendedSpots: PropTypes.number,
};

export default ProjectedSpotsConfirmation;
